module.exports = __webpack_public_path__ + "img/delivery.4884dc74.svg";